export default {
  add_rate: 'Dodaj stawkę',
  remove_rate: 'Usuń stawkę',
  gateways: {
    adyen: 'Adyen',
  },
  methods: {
    fallback: 'Dowolna metoda płatności',
    card: 'Karta',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    link: 'Link',
    paypal: 'PayPal',
    pay_by_bank: 'Pay by Bank',
    sepa_debit: 'Polecenie zapłaty SEPA',
    sofort: 'Sofort',
    giropay: 'giropay',
    bacs_debit: 'Polecenie zapłaty Bacs',
    stripe_other: 'Inne metody Stripe',
  },
  fields: {
    percentage: 'Procent',
    fixed: 'Kwota stała',
    min: 'Kwota minimalna',
  },
  // Spelled out from the row's own values, so a rate reads as the fee it
  // produces. {{method}} is the payment method, {{fixed}}/{{floor}} are
  // formatted amounts, {{percentage}} is a plain number.
  explanation: {
    none: 'Za płatności metodą {{method}} nie jest jeszcze naliczana żadna opłata — dopóki nie ustawisz stawki, marża na tych płatnościach wynosi 0%.',
    floor_only:
      'Przy metodzie {{method}} opłata za przetwarzanie wynosi {{floor}} od każdej płatności, niezależnie od kwoty zamówienia.',
    percentage: 'Przy metodzie {{method}} opłata za przetwarzanie wynosi {{percentage}}% wartości zamówienia.',
    percentage_floor:
      'Przy metodzie {{method}} opłata za przetwarzanie wynosi {{percentage}}% wartości zamówienia, jednak nie mniej niż {{floor}}.',
    fixed: 'Przy metodzie {{method}} opłata za przetwarzanie wynosi {{fixed}} za płatność.',
    fixed_floor:
      'Przy metodzie {{method}} opłata za przetwarzanie wynosi {{fixed}} za płatność, jednak nie mniej niż {{floor}}.',
    combined:
      'Przy metodzie {{method}} opłata za przetwarzanie to {{fixed}} stałej kwoty plus {{percentage}}% wartości zamówienia.',
    combined_floor:
      'Przy metodzie {{method}} opłata za przetwarzanie to {{fixed}} stałej kwoty plus {{percentage}}% wartości zamówienia, jednak nie mniej niż {{floor}}.',
    redundant_floor:
      'Minimum {{floor}} nigdy nie zadziała — kwota stała już przy każdej płatności osiąga tę wartość. Ustaw je powyżej {{fixed}} albo wyczyść pole.',
  },
  example: 'Przykład: przy zamówieniu na {{total}} opłata za przetwarzanie wynosi {{fee}}.',
};
